export default __webpack_public_path__ + "media/zurb/img/work/tcl/tcl-multitask-df4352f0b8d821ed5321a418265a709d.gif";